<template>
    <div class="entryGoods">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
            <div class="entery_title">
                <div class="line"></div>
                <div class="base_title">基本信息</div>
            </div>
            <el-form-item label="视频号 id:" prop="videoId">
                <el-input v-model="ruleForm.videoId" style="width: 250px;" placeholder="请输入视频号 id"></el-input>
            </el-form-item>
            <el-form-item label="视频号名称:" prop="videoName">
                <el-input v-model="ruleForm.videoName" style="width: 250px;" placeholder="请输入视频名称"></el-input>
            </el-form-item>
            <div class="entery_title">
                <div class="line"></div>
                <div class="base_title">视频 id</div>
                <div class="fuwenben">(可添加多个视频 id，展示多个视频)</div>
            </div>
            <el-button class="addShuxing" type="primary" icon="el-icon-plus" @click="open">添加视频</el-button>
            <el-form-item class="videoList" v-for="(item, index) in ruleForm.videoList" :key="index">
                <div class="videoList_item">
                    <el-input v-model="ruleForm.videoList[index]" style="width: 250px;"
                        placeholder="请输入视频 id"></el-input>
                    <el-button type="danger" @click="handleClose(index)" icon="el-icon-delete"></el-button>
                </div>
            </el-form-item>
            <el-form-item label-width="0px" style="margin-top: 50px;">
                <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
export default {
    data() {
        return {
            ruleForm: {
                videoList: [],
            },
            rules: {
                videoId: [
                    { required: true, message: "请输入视频号 id", trigger: "blur" },
                ],
                videoName: [
                    { required: true, message: "请输入视频号名称", trigger: "blur" },
                ]
            }
        };
    },
    methods: {
        // 新增视频 id
        open() {
            this.ruleForm.videoList.push('');
        },
        // 删除视频 id
        handleClose(index) {
            this.ruleForm.videoList.splice(index, 1);
        },
        // 保存
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    // 将 videoList 转换为指定格式的字符串
                    const videoListString = this.ruleForm.videoList.join(',');
                    this.ruleForm.videoList = videoListString
                    let videoItem = this.ruleForm
                    this.$axios.post(this.$url.saveEntVideo, videoItem).then(res => {
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        });
                        this.getVideoList()
                    });
                }
            });
        },
        // 获取视频号信息
        getVideoList() {
            this.$axios.get(this.$url.getAccountSetting).then(res => {
                let entCode = res.data.entCode;
                //企业信息
                this.$axios
                    .get(this.$url.getWebVideoInfo, {
                        entCode: entCode
                    })
                    .then(res => {
                        this.ruleForm = res.data
                    });
            });
        }
    },
    created() {
        this.getVideoList()
    }
};
</script>

<style lang="less" scoped>
.entryGoods {
    position: relative;
    width: 100%;
    padding: 30px;
    background: #ffffff;
    box-sizing: border-box;
}

.entery_title {
    display: flex;
    align-items: center;
    margin-bottom: 20px;

    .line {
        width: 3px;
        height: 19px;
        margin-right: 5px;
        background: rgba(102, 102, 102, 1);
    }

    .base_title {
        font-size: 18px;
        font-weight: bold;
        margin-right: 5px;
        color: rgba(51, 51, 51, 1);
    }

    .fuwenben {
        font-size: 14px;
        font-weight: 400;
        color: rgba(245, 108, 108, 1);
    }
}

.videoList {
    margin-top: 20px;
    // width: 300px;

    .videoList_item {
        display: flex;
        box-sizing: border-box;
    }

    ::v-deep.el-button {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 36px !important;
        height: 36px !important;
    }

    ::v-deep.shuxi {
        .el-input__inner {
            width: 188px !important;
        }

        width: 188px !important;
        margin-right: 16px;
    }

    ::v-deep.number {
        .el-input__inner {
            width: 320px !important;
        }

        width: 320px !important;
        margin-right: 16px;
    }
}
</style>